import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.object.to-string.js";
/**
 * The axis ticks for scores normalised to their bands' positions: 0, then 1 for the lowest band
 * up to the number of bands. Label each with `getHelixScoreBandTickLabel`.
 * @param scoreBands - The bands, sorted by their starting score
 * @returns The ticks, lowest first
 */
export function getHelixScoreBandTicks(scoreBands) {
  return [0].concat(_toConsumableArray(scoreBands.map(function (_band, index) {
    return index + 1;
  })));
}

/**
 * The label for an axis tick from `getHelixScoreBandTicks`: the name of the band at that
 * position, and nothing for 0, which is no band.
 * @param value - The tick's value
 * @param scoreBands - The bands, sorted by their starting score
 * @returns The band's name, or an empty string
 */
export function getHelixScoreBandTickLabel(value, scoreBands) {
  var _scoreBands$label, _scoreBands;
  return (_scoreBands$label = (_scoreBands = scoreBands[Number(value) - 1]) === null || _scoreBands === void 0 ? void 0 : _scoreBands.label) !== null && _scoreBands$label !== void 0 ? _scoreBands$label : '';
}
/**
 * The band a score shown on a chart falls in. A raw score is in the band with the highest
 * starting score it reaches - mirrors getScoreBand in the API. A normalised score is its band's
 * position, 1 for the lowest band.
 * @param value - The score, as the API returned it
 * @param options - The bands, and whether the value is normalised
 * @param options.scoreBands - The bands, sorted by their starting score
 * @param options.normalised - Whether the value is normalised to its band's position
 * @returns The band, or null if the value has none
 */
export default function getHelixScoreBand(value, _ref) {
  var _scoreBands$findLast;
  var scoreBands = _ref.scoreBands,
    _ref$normalised = _ref.normalised,
    normalised = _ref$normalised === void 0 ? false : _ref$normalised;
  if (value === null || value === undefined || value === '') {
    return null;
  }
  var numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return null;
  }
  if (normalised) {
    var _scoreBands2;
    return (_scoreBands2 = scoreBands[numericValue - 1]) !== null && _scoreBands2 !== void 0 ? _scoreBands2 : null;
  }
  return (_scoreBands$findLast = scoreBands.findLast(function (_ref2) {
    var min = _ref2.min;
    return min <= numericValue;
  })) !== null && _scoreBands$findLast !== void 0 ? _scoreBands$findLast : null;
}